import { render, staticRenderFns } from "./EditFaqTagModal.vue?vue&type=template&id=503c15b7&"
import script from "./EditFaqTagModal.vue?vue&type=script&lang=js&"
export * from "./EditFaqTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports